import { Routing } from 'helpers/routing'
import React, { createContext } from 'react'

const TeamOrganizationContext = createContext<{
  params?: Routing.TeamOrganizationParams
}>({})

export { TeamOrganizationContext }
